import React, { useState, useEffect } from "react";
import Addword from "../../AddWord/Addword";
// Icons
import CloseIcon from "@material-ui/icons/Close";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import iconError from "../../../assets/img/perlingo-buttonn.gif";
// material-ui
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import {
  CompassCalibrationOutlined,
  SignalCellularNoSimOutlined,
} from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  setWordInAnswer,
  setCorrectAnswerNew,
  setWordsMain,
  setArrayNewWorldFooter,
  setNewArrayFooterUi,
  setLanguageType,
} from "../../../redux/action/user";
import {
  setEditCorrectAnswer,
  setEditLanguage,
  setEditWord,
  setEditWords,
} from "../../../redux/action/Edit";
import ControlledOpenSelect from "../../AddWord/SelectLanguage";

export default function SelectWord(props) {
  // State
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const EditState = useSelector((state) => state.Edit);
  const [filterWord, setFilterWord] = useState([]);
  const [filterWordEn, setFilterEn] = useState([]);
  const [filterChangeLangFa, setLangFa] = useState([]);
  const [chosenWord, setChosenWord] = useState([]);
  const [checkedValue, setCheckedVaue] = useState();
  const [lang, setLang] = useState(user.typeLanguage);
  const [langBlankChoise, setLangBlankChoise] = useState("fa");
  const [blantBoolean, setBlankBoolean] = useState();
  const [tagNewArray, setTagNewArray] = useState();
  const [radioON, setRadioON] = useState();
  const [radioONindex, setRadioONIndex] = useState();
  let whichRadioOn = [];
  let whichradioONindex;
  const FindwhichRadioOn = () => {
    if (EditState.edit && EditState.type === "BT") {
      console.log(EditState.word, "bt")
      whichRadioOn =
        EditState.edit && EditState.word.filter((item) => item.blank === true);
      whichradioONindex = EditState.edit && EditState.word.findIndex((item) => item.blank === true);
    }
    if (EditState.edit && EditState.type === "B") {
      whichRadioOn =
        EditState.edit && EditState.words.filter((item) => item.blank === true);
    }
  };
  useEffect(() => {
    if (EditState.edit) {
      FindwhichRadioOn();
      setRadioON(whichRadioOn[0].word);
      setRadioONIndex(whichradioONindex + 1);
    }
  }, []);

  var newArrayFooter = [];
  var newArrayFooterUi = [];
  var checkedFirstValue;

  // Functions
  const handleBlankType = async (e, index) => {

    await setRadioON(e.target.value);
    setRadioONIndex(index + 1)
    setBlankBoolean(e.target.value);
    onChangeHandler(e.target.value, tagNewArray, index + 1);
  };

  if (EditState.type === "B") {
    var answerBlanktypeEdit =
      EditState.edit && EditState.words ? EditState.words : undefined;
  } else if (EditState.type === "BT") {
    var answerBlanktypeEdit =
      EditState.edit && EditState.word ? EditState.word : undefined;
  }
  var newArrayTest = [];
  var newArrayanswerBlank = [];
  answerBlanktypeEdit?.map((item, index) => {
    return newArrayanswerBlank.push({
      blank: item.blank,
      word_id: item.word_id && item.word_id._id,
      word: item?.word_id?.word,
      id: index + 1,
    });
  });

  const onChangeHandler = (e, value, indexCorrect) => {
    if (EditState.edit && value === undefined) {
      value = newArrayanswerBlank;
    }
    console.log(value);
    value?.forEach((item, index) => {
      newArrayTest.push({
        word_id: item.word_id ? item.word_id : item._id,
        word: item.word,
        id: index + 1,
        blank: indexCorrect ?
          (e === item.word && indexCorrect === index + 1 ?
            true :
            false)
          :
          (radioON === item.word && radioONindex === index + 1 ?
            true :
            false)
      });

      newArrayFooter.push(item.word);
    });
    user.conditionalType !== "BT" &&
      value.forEach((item) => {
        newArrayFooterUi.push({ word: item.word });
        dispatch(setNewArrayFooterUi(newArrayFooterUi));
      });

    //=========================================================== shold be checked type :)

    // dispatch(setArrayNewWorldFooter(newArrayFooter));
    //===================
    if (props.type === "blank-type") {
      dispatch(setWordInAnswer(newArrayTest));
      dispatch(setEditWord(newArrayTest));
    }
    if (props.type === "blanck-choies") {
      dispatch(setWordsMain(newArrayTest));
      dispatch(setEditWords(newArrayTest));
    }
    if (props.type === "blanck-choies") {
      let answer = [];
      value.forEach((item) =>
        answer.push({ word: item.word, word_id: item._id })
      );
      // dispatch(setWordInAnswer(answer));
    }
    setTagNewArray(value);
    console.log(newArrayTest, "newArrayTest")
    var result = newArrayTest?.findIndex((correct) => correct.blank === true);

    if (props.type === "blank-type") {
      dispatch(setCorrectAnswerNew([newArrayTest[result] ? newArrayTest[result].word : radioON]));
      dispatch(setEditCorrectAnswer([newArrayTest[result] ? newArrayTest[result].word : radioON]));
      if (EditState.edit && newArrayTest[result] === undefined) {
        let index = newArrayTest?.findIndex(item => item.word === radioON)
        newArrayTest[index].blank = true
      }
    }
  };
  console.log(radioON, "radioON")
  const SaveSelectedWords = () => {
    props.setSelectedWord(chosenWord);

    let answer = [];
    chosenWord.forEach((item) =>
      answer.push({
        word: item.word,
        word_id: item.word_id ? item.word_id : item._id,
      })
    );
    dispatch(setWordInAnswer(answer));
    dispatch(setEditWord(answer));
    props.closeflashCartModal();
  };

  const handleAddflashcart = (e) => {
    if (e.keyCode === 13) {
      SaveSelectedWords();
    }
  };

  const handleFilterWord = (words, language) => {
    setFilterWord((filterWord) =>
      props.Words?.filter((word) => word.language === language)
    );
    // setLangBlankChoise(language);
    dispatch(setLanguageType(language));
    EditState.edit && dispatch(setEditLanguage(language));
    console.log(langBlankChoise, "langBlankChoise 0");
  };

  console.log(filterWord, "filterWord");

  const handleChangeEn = (words, LANGUAGE) => {
    console.log(langBlankChoise, "langBlankChoise 1");
    setFilterEn(words?.filter((word) => word.language === LANGUAGE));
  };

  const handleFilterFa = (words, LANGUAGE) => {
    console.log(langBlankChoise, "langBlankChoise 2");
    setLangFa(words?.filter((word) => word.language === LANGUAGE));
  };

  useEffect(() => {
    if (EditState.edit) {
      if (EditState.language === "fa") {
        handleFilterWord(props.Words, "fa");
      } else {
        handleFilterWord(props.Words, "en");
      }

      setChosenWord(props.selectedWord);
      if (EditState.language === "fa") {
        handleChangeEn(props.Words, "en");
        handleFilterFa(props.Words, "fa");
      } else {
        handleChangeEn(props.Words, "fa");
        handleFilterFa(props.Words, "en");
      }

    } else {
      handleFilterWord(props.Words, "fa");
      setChosenWord(props.selectedWord);
      handleChangeEn(props.Words, "en");
      handleFilterFa(props.Words, "fa");
    }
  }, [props.Words]);

  // useEffect(() => {
  //   EditState.edit && setLangBlankChoise(EditState.language);
  // }, [EditState.language]);

  useEffect(() => {
    handleChangeEn(props.Words, langBlankChoise);
    handleFilterFa(props.Words, langBlankChoise);
  }, [langBlankChoise]);

  const changeLang = () => { };
  useEffect(() => {
    changeLang();
  }, []);
  useEffect(() => {
    setLang(user.typeLanguage);
  }, [user.typeLanguage]);

  const funcCheckedValueFirst = (event) => {
    setCheckedVaue(event);
  };
  user.wordAnswer.filter((item) => (item.blank !== true, "rrwwweeeqqq"));
  const errorModalBlank = user.wordsMain.filter((item) => item.blank === true);

  let langWord = [];
  return (
    <>
      <div
        className="outline-none h-fill"
      // onKeyDown={(e) => handleAddflashcart(e)}
      // tabIndex="0"
      >
        <div className="container">
          <div className="row">
            <div class=" d-block d-md-flex w-100 mt-3 mt-lg-5 ">
              {props.type === "blanck-choies" ? (
                <div
                  className={`d-flex justify-content-center align-items-center style-language languages_${langBlankChoise}`}
                >
                  <button
                    className={`btn ${langBlankChoise === "fa" ? "text_bold" : ""
                      }`}
                    onClick={() => handleFilterWord(props.Words, "fa")}
                  // onChange={() => handleFilterWord(props.Words, "fa")}
                  >
                    Fa
                  </button>
                  <span>|</span>
                  <button
                    onClick={() => handleFilterWord(props.Words, "en")}
                    // onChange={() => handleChangeEn(props.Words, "en")}
                    className={`btn ${langBlankChoise === "en" ? "text_bold" : ""
                      }`}
                  >
                    En
                  </button>
                </div>
              ) : (
                <>
                  {/* <button
                    className={`btn ${lang === "en" ? "text_bold" : ""}`}
                    onChange={() =>
                      handleFilterWord(
                        props.Words,
                        user.typeLanguage === "fa" ? "en" : "fa"
                      )
                    }
                  >
                    En
                  </button>
                  <button
                    className={`btn ${lang === "fa" ? "text_bold" : ""}`}
                    onChange={() =>
                      handleFilterWord(
                        props.Words,
                        user.typeLanguage === "fa" ? "en" : "fa"
                      )
                    }
                  >
                    Fa
                  </button> */}
                </>
              )}

              <Autocomplete
                // defaultValue={
                //   props.selectedWord &&
                //   props.selectedWord.map((option) => option)
                // }
                onChange={(e, v) => onChangeHandler(e, v)}
                className={`rtl flashcart_taginput_${langBlankChoise} w-100 ${user.typeLanguage === "fa" &&
                  props.type === "blank-type" &&
                  "LtrOption"
                  }`}
                multiple
                filterSelectedOptions
                id="tags-standard"
                options={
                  (console.log(
                    user.typeLanguage,
                    "user.typeLanguage",
                    props.type,
                    "props.type"
                  ),
                    user.typeLanguage === "fa" && props.type === "blank-type"
                      ? ((langWord = props.Words?.filter(
                        (word) => word.language === "fa"
                      )),
                        langWord.map((option) => option))
                      : ((langWord = props.Words?.filter(
                        (word) => word.language === "en"
                      )),
                        langWord.map((option) => option)),
                    // langWord = filterWord?.filter((word) => word.language === langBlankChoise),
                    // console.log(langWord,"langBlankChoise"),
                    // () => setFilterWord(filterWord => langWord ),
                    // filterWord && filterWord.map((option) => option)
                    // props.type === "blank-type" && lang === "en" ? (
                    //   filterChangeLangFa &&
                    //   filterChangeLangFa.map((option) => option)
                    // ) : props.type === "blank-type" && lang === "fa" ? (
                    //   filterWordEn && filterWordEn.map((option) => option)
                    // ) : (
                    //   props.Words && props.Words.map((option) => option)
                    // ),
                    //MyCode

                    user.typeLanguage === "fa" && props.type === "blank-type"
                      ? ((langWord = props.Words?.filter(
                        (word) => word.language === "en"
                      )),
                        langWord.map((option) => option))
                      : ((langWord = props.Words?.filter(
                        (word) => word.language === "fa"
                      )),
                        langWord.map((option) => option)))
                }
                defaultValue={
                  newArrayanswerBlank && newArrayanswerBlank.map((item) => item)
                }
                getOptionLabel={(option) => option.word}
                getOptionDisabled={(options) => options}
                getOptionSelected={(option, value) => {
                  //nothing that is put in here will cause the warning to go away
                  if (value === "") {
                    return true;
                  } else if (value === option.word) {
                    return true;
                  }
                }}
                autoComplete
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    option.id = index + 1
                    return (
                      <Chip
                        variant="outlined"
                        label={option.word}
                        size="small"
                        {...getTagProps({ index })}
                        className="test"
                        icon={
                          <div className="input-radio-submit-word">
                            <input
                              type="radio"
                              name="test"
                              value={
                                newArrayanswerBlank ? option.word : option.word
                              }
                              checked={radioON === option.word && radioONindex === option.id ? true : false}
                              onChange={(e) => handleBlankType(e, index)}
                            />
                          </div>
                        }
                      />
                    );
                  })
                }
                renderInput={(params) => (
                  <TextField
                    className="placeholder_style"
                    {...params}
                    variant="filled"
                    placeholder={
                      langBlankChoise === "fa" ? "انتخاب کلمه " : "Chose word"
                    }
                    autoComplete="off"
                  />
                )}
              />
            </div>
          </div>
          {errorModalBlank.length === 0 ? (
            <div className="style-text">
              <div className="style-gif float-left ">
                {" "}
                <img src={iconError} alt={iconError} />
              </div>
              <p> لطفا یکی از گزینه هارا انتخاب کنید</p>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}
